import axiosInstance from "../../../axios/axios";

export function getOwnerServicesTypes() {
    return new Promise((resolve, reject) => {
        axiosInstance.get(`/ownerservicessubscriptions/getownerservices`).then(response => {
            if (response.status == 200) {
                if (response.data.status?.responseCode == "200") {
                    const res = response?.data?.result ?? [];
                    const formattedResponse = res.map((service) => ({
                        text: service?.name,
                        label: service?.name,
                        value: service?.id,
                        ...service
                    }))

                    resolve(formattedResponse ?? []);
                }
            }
            resolve(false);
        }).catch(error => reject(false))
    })
}

export function sendOwnerServicesData(formData) {
    return new Promise((resolve, reject) => {
        axiosInstance.post(`/ownerservicessubscriptions/ownerservicessubscription`, formData, {
            headers: {
                'content-type': 'multipart/form-data',
            }
        }).then(response => {
            debugger;
            resolve(response ?? []);
            // if (response.status == 200) {
            //     if (response.data.status?.responseCode == "200") {
            //         const res = response?.data?.result ?? [];


            //     }
            // }
            resolve(false);
        }).catch(error => reject(false))
    })
}